import Big from 'big.js'
import { writable } from 'svelte/store'

import { browser } from '$app/environment'
import { apiFetchJson } from '$lib/proxy/apiProxy'
import type { Tax } from '$lib/types/client_types'
import type { ServerTax } from '$lib/types/server_types'


const store = writable([] as Tax[])
export { store as accTaxes_store }

let promiseFetch: Promise<Tax[]>
let state: 'pending' | 'reading' | 'ready' = 'pending'

export const InitAccTaxes = async (pFetch = fetch, force = false) => {
	// if SSR just return the promise data
	if (!browser) return fetchData(pFetch)

	if (!force && state === 'ready') return
	if (!force && state === 'reading') {
		await promiseFetch
		return true
	}

	promiseFetch = fetchData(pFetch)
	await promiseFetch
	return true
}

const fetchData = async (pFetch = fetch) => {
	if (browser) state = 'reading'

	const body = JSON.stringify({
		archived: [false, true],
		query: '',
		withName: true,
		tax_id: undefined
	})
	const jsonData = await apiFetchJson(pFetch, 'post', '/taxes', undefined, body)
	if (!jsonData || jsonData.error) {
		if (browser) state = 'pending'
		return []
	}

	const data = parseServerTaxes(jsonData.taxes)
	if (browser) {
		store.set(data)
		state = 'ready'
	}

	return data
}

export function parseServerTaxes(taxes: ServerTax[]): Tax[] {
	return taxes.map((tax) => {
		return { ...tax, rate: Big(tax.rate) }	
	})
}
